import { isBefore } from "date-fns/fp";
import type { Offer } from "./index";

const isExpired = ({ expiresAt }: Offer): boolean =>
  !!expiresAt && isBefore(new Date())(new Date(expiresAt));

export default isExpired;
